import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ProgramEnterEventDataObject } from 'models/service';

type EnterEventRequestData = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  email?: string;
  exit_uri: string;
  first_name?: string;
  invitation_token?: string;
  last_name?: string;
  user_ids?: string[];
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const enterEvent = async (id: string, data: EnterEventRequestData) =>
  apiClient.post<ProgramEnterEventDataObject, ApiClientResponse<ProgramEnterEventDataObject>>(
    routes.events.enter(id),
    data,
  );
